<template>
<v-layout>
  <v-flex>
<v-form>
<v-container fluid align-center grid-list-md>
  <v-layout align-center justify-center row>
    <v-flex xs12>
      <h1 align="center"> Billing</h1>
    </v-flex>
  </v-layout>
<my-inv-head></my-inv-head>

<my-sale-form ></my-sale-form>
<my-print-list/>
<my-sale-item></my-sale-item>



<tax-Summary></tax-Summary> 

 
  


</v-container>
</v-form>
  </v-flex>
</v-layout>


</template>

<script>
import api from '@/services/cas'
export default {
  data() {
    return {
      tax: [],
      i: 0,
    }
  },
  components: {
    'my-sale-form': () => import ('@/components/saleform'),
    'my-sale-item': () => import ('@/components/saleitem'),
    'my-inv-head': () => import ('@/components/invoicehead'),
    'tax-Summary': () => import('@/components/taxSummary.vue'),
    'my-print-list': () => import('@/components/printList.vue'),
    
  },

  computed: {
   
  },
  async mounted() {
  //   const items = (await api.fetchItem()).data
  //   const st_code =(await api.fetchStates()).data
  //  // const party = (await api.fetchParty(false)).data
  //   //console.log(party + 'form')
  //   this.$store.state.invoice.items = items
  //   this.$store.state.invoice.st_code=st_code
  //   //this.$store.state.invoice.partyList = party
    
    //console.log(this.$store.state.company)
    //console.log(this.$store.getters.invoice.getItems)

    // this.$store.dispatch('invoice/fetchParty',false)
  },

  methods: {
    sav() {


        this.i = +1

      api.submit()

    }
  }
}
</script>
